import axios from 'axios';
import { AddressableMapping } from '@repo/alictus-common/types/addressable';
import config from '../config';
import globalStore from '../store';

export const fetchMappingData = async (signal?: AbortSignal) => {
	const { JWTToken, gameId } = globalStore.getState();
	const url = `${config.CLOUDFLARE_LOCAL_ENDPOINT}/game/${gameId}/addressable_mapping`;
	const response = await axios.get(url, {
		headers: { Authorization: `Bearer ${JWTToken}` },
		signal,
	});
	return response.data;
};

export const fetchReportData = async (signal?: AbortSignal) => {
	const { JWTToken, gameId } = globalStore.getState();
	const url = `${config.CLOUDFLARE_LOCAL_ENDPOINT}/game/${gameId}/addressable_mapping/build_status`;
	const response = await axios.get(url, {
		headers: { Authorization: `Bearer ${JWTToken}` },
		signal,
	});
	return response.data;
};

export const createMapping = async (
	JWTToken: string,
	gameId: string,
	data: Omit<AddressableMapping, 'id' | 'isActive' | 'isOverWritten' | 'updatedBy' | 'lastUpdated'>,
): Promise<AddressableMapping> => {
	const url = `${config.CLOUDFLARE_LOCAL_ENDPOINT}/game/${gameId}/addressable_mapping`;
	const response = await axios.post(url, data, {
		headers: { Authorization: `Bearer ${JWTToken}` },
	});
	return response.data;
};

export const updateMapping = async (
	JWTToken: string,
	gameId: string,
	mappingId: number,
	data: Omit<AddressableMapping, 'isActive' | 'isOverWritten' | 'updatedBy' | 'lastUpdated'>,
): Promise<AddressableMapping> => {
	const url = `${config.CLOUDFLARE_LOCAL_ENDPOINT}/game/${gameId}/addressable_mapping/${mappingId}`;
	const response = await axios.put(url, data, {
		headers: { Authorization: `Bearer ${JWTToken}` },
	});
	return response.data;
};

export const deleteMapping = async (JWTToken: string, gameId: string, mappingId: number) => {
	const url = `${config.CLOUDFLARE_LOCAL_ENDPOINT}/game/${gameId}/addressable_mapping/${mappingId}`;
	await axios.delete(url, {
		headers: { Authorization: `Bearer ${JWTToken}` },
	});
};
